
export default {
  meta: {
    seo: {
      title: 'pages.blog',
      description: 'blog.description'
    }
  },
  vessel: {
    title: {
      fontSize: '3xl',
      marginBottom: 'sm',
    },
    text: {
      marginBottom: 'lg',
      lineHeight: 'lg'
    }
  },
  async asyncData ({ $content, app: { i18n: { locale } } }) {
    const posts = await $content(locale, 'posts')
      .without(['body'])
      .sortBy('publishedAt', 'desc')
      .fetch()

    return { posts }
  },
  data() {
    return {
      title: this.$t('pages.blog')
    }
  }
}
